





























// import React, { useState, useEffect } from "react";
// import "../assets/AttendanceCalculator.css";
// import { toast, ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import { useDispatch, useSelector } from "react-redux";
// import { fetchEmployeeReport } from "../redux/slices/employeeReportSlice";
// import axios from "axios";

// const SuperAdminAttendance = () => {
//   const dispatch = useDispatch();

//   const { list: employeeList, loading: empLoading } = useSelector(
//     (state) => state.employeeReport
//   );

//   const [selectedUser, setSelectedUser] = useState("");
//   const [selectedUserId, setSelectedUserId] = useState(null);
//   const [selectedBranchId, setSelectedBranchId] = useState(null);
//   const [superAdminId, setsuperadminid] = useState(null);

//   const [selectedMonth, setSelectedMonth] = useState(new Date().toISOString().slice(0, 7));
//   const [attendanceData, setAttendanceData] = useState([]);
//   const [loading, setLoading] = useState(false);

//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [formData, setFormData] = useState({
//     employee_id: "",
//     attendance_date: "",
//     attendance_time: "09:30",
//     checkout_time: "18:30",
//   });

//   useEffect(() => {
//     dispatch(fetchEmployeeReport({ page: 1, pageSize: 100, filterType: "userId" }));
//   }, [dispatch]);

//   useEffect(() => {
//     if (selectedUserId) setFormData((prev) => ({ ...prev, employee_id: selectedUserId }));
//   }, [selectedUserId]);

//   const formatTime = (timeValue) => {
//     if (!timeValue) return "--";
//     if (/^\d{2}:\d{2}$/.test(timeValue)) return timeValue;
//     const dateObj = new Date(timeValue);
//     if (isNaN(dateObj)) return "--";
//     return dateObj.toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit", hour12: false, timeZone: "Asia/Kolkata" });
//   };

//   const fetchAttendanceData = async () => {
//     if (!selectedUserId || !selectedMonth) {
//       toast.info("Please select both user and month!");
//       return;
//     }
//     setLoading(true);
//     try {
//       // const res = await fetch(`https://narrowitsolution.in/api/attendance/status?employee_id=${selectedUserId}&month=${selectedMonth}`);



//             const res = await fetch(`https://narrowitsolution.in/api/attendance/status?admin_id=52&month=${selectedMonth}`);

//       const result = await res.json();

      
//       if (result?.data?.length) {
//         const mapped = result.data.map((r) => ({
//           id: r.id,
//           date: r.date,
//           checkIn: r.check_in_time || r.checkInTime ? formatTime(r.check_in_time || r.checkInTime) : "--",
//           checkOut: r.check_out_time || r.checkOutTime ? formatTime(r.check_out_time || r.checkOutTime) : "--",
//           status: (r.status || "absent").trim().toLowerCase(),
//         }));
//         setAttendanceData(mapped);
//       } else {
//         toast.info("No records found.");
//         setAttendanceData([]);
//       }
//     } catch (err) {
//       toast.error("❌ Failed to fetch data!");
//     } finally {
//       setLoading(false);
//     }
//   };






//   const handleSave = async (row) => {
//   try {
//     const payload = {
//       employee_id: Number(selectedUserId),
//       attendance_date: row.date, // YYYY-MM-DD

//       // Convert HH:mm → HH:mm:ss
//       attendance_time:
//         row.checkIn && row.checkIn !== "--"
//           ? `${row.checkIn}:00`
//           : "09:30:00",

//       // Convert to full DATETIME or null
//       checkout_time:
//         row.checkOut && row.checkOut !== "--"
//           ? `${row.date} ${row.checkOut}:00`
//           : null,

//       // 🔥 THIS IS IMPORTANT
//       manual_status: row.status
//     };

//     console.log("UPDATE PAYLOAD:", payload);

//     const res = await axios.put(
//       "https://narrowitsolution.in/api/attendance/update",
//       payload
//     );

//     if (res.status === 200 || res.status === 201) {
//       toast.success(`✅ Attendance for ${row.date} updated`);
//       fetchAttendanceData();
//     }
//   } catch (error) {
//     console.error("Update Error:", error);
//     toast.error(
//       error.response?.data?.error ||
//       error.response?.data?.message ||
//       "❌ Attendance update failed"
//     );
//   }
// };

//   const handleAttendanceChange = (index, field, value) => {
//     const updated = [...attendanceData];
//     updated[index][field] = value;
//     setAttendanceData(updated);
//   };

//   // Rest of handleCreateSubmit and handlecalcclick remains the same...
//   const handleCreateSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       const payload = {
//         employee_id: Number(formData.employee_id),
//         attendance_date: formData.attendance_date,
//         attendance_time: `${formData.attendance_time}:00`,
//         checkout_time: `${formData.attendance_date} ${formData.checkout_time}:00`,
//       };
//       const res = await axios.post("https://narrowitsolution.in/api/create-attendence/custom", payload);
//       if (res.status === 200 || res.status === 201) {
//         toast.success("✅ Attendance Created!");
//         setIsModalOpen(false);
//         fetchAttendanceData();
//       }
//     } catch (error) {
      
      
//       toast.error(
//       error.response?.data?.error ||
//       error.response?.data?.message ||
//       "Creation failed"
//     );}
//   };

// const handlecalcclick = async () => {
//   const [year, month] = selectedMonth.split("-");
//   try {
//     const payload = { employeeId: selectedUserId, month, year, superAdminId, branchId: selectedBranchId };
//     const response = await axios.post("https://narrowitsolution.in/api/attendence/finalize-new", payload);

//     console.log("SERVER RESPONSE:", response.data); // <--- ADD THIS LOG

//     if (response.data.success === true || response.data.success === "true") {
//       toast.success("Salary finalized successfully!");
//     } else {
//       toast.error(response.data.message || "Finalization failed.");
//     }
//   } catch (error) {
//     console.error("CATCH ERROR:", error); // <--- ADD THIS LOG
//     toast.error(error.response?.data?.message || "An unexpected error occurred.");
//   }
// };

//   return (
//     <div className="SuperAdminAttendance-container">
//       <div className="SuperAdminAttendance-header">
//         <h1 className="SuperAdminAttendance-title"> Attendance Panel</h1>
//         <button className="create-att-btn" onClick={() => setIsModalOpen(true)}>+ Create Attendance</button>
//       </div>

//       <div className="SuperAdminAttendance-filters">
//         <div className="SuperAdminAttendance-filterGroup">
//           <label className="SuperAdminAttendance-label">Select User</label>
//           <select className="SuperAdminAttendance-input" value={selectedUserId || ""} onChange={(e) => {
//               const userId = Number(e.target.value);
//               const userObj = employeeList?.find((u) => u.id === userId);
//               setSelectedUser(userObj?.fullName);
//               setSelectedUserId(userObj?.id || null);
//               setSelectedBranchId(userObj?.branchId || null);
//               setsuperadminid(userObj?.superAdminId || null);
//             }}>
//             <option value="">Select User</option>
//             {employeeList?.map((u) => (<option key={u.id} value={u.id}>{u.fullName} ({u.branchName})</option>))}
//           </select>
//         </div>
//         <div className="SuperAdminAttendance-filterGroup">
//           <label className="SuperAdminAttendance-label">Select Month</label>
//           <input type="month" className="SuperAdminAttendance-input" value={selectedMonth} onChange={(e) => setSelectedMonth(e.target.value)} />
//         </div>
//         <div className="SuperAdminAttendance-filterGroup">
//           <label className="SuperAdminAttendance-label">&nbsp;</label>
//           <button className="SuperAdminAttendance-btn" onClick={fetchAttendanceData} disabled={loading}>Filter</button>
//         </div>
//       </div>

//       {selectedUser && attendanceData.length > 0 && (
//         <div className="SuperAdminAttendance-userMonthly">
//           <h2 className="SuperAdminAttendance-subtitle">Monthly Summary - {selectedUser}</h2>
//           <div className="SuperAdminAttendance-summary">
//             <div className="SuperAdminAttendance-card green"><h2>Days Present</h2><p>{attendanceData.filter(a => ["present", "late", "late present"].includes(a.status)).length}</p></div>
//             <div className="SuperAdminAttendance-card purple"><h2>Half Days</h2><p>{attendanceData.filter(a => a.status === "half day").length}</p></div>
//             <div className="SuperAdminAttendance-card red"><h2>Leaves / Absent</h2><p>{attendanceData.filter(a => ["leave", "absent"].includes(a.status)).length}</p></div>
//             <div className="SuperAdminAttendance-card blue"><h2>Total Days</h2><p>{attendanceData.length}</p></div>
//           </div>
//         </div>
//       )}

//       {selectedUser && (
//         <div className="SuperAdminAttendance-tableWrapper">
//           <h2 className="SuperAdminAttendance-subtitle">Manage Daily Attendance</h2>
//           <table className="SuperAdminAttendance-table">
//             <thead>
//               <tr>
//                 <th>Date</th>
//                 <th>Status</th>
//                 <th>Check-In</th>
//                 <th>Check-Out</th>
//                 <th>Action</th>
//               </tr>
//             </thead>
//             <tbody>
//               {attendanceData.map((row, index) => (
//                 <tr key={index}>
//                   <td>{row.date}</td>
//                   <td>
//                     <select value={row.status} onChange={(e) => handleAttendanceChange(index, "status", e.target.value)}>
//                       <option value="present">Present</option>
//                       <option value="late">Late</option>
//                       <option value="half day">Half Day</option>
//                       <option value="leave">Leave</option>
//                       <option value="absent">Absent</option>
//                     </select>
//                   </td>
//                   <td><input type="time" value={row.checkIn !== "--" ? row.checkIn : ""} onChange={(e) => handleAttendanceChange(index, "checkIn", e.target.value)} /></td>
//                   <td><input type="time" value={row.checkOut !== "--" ? row.checkOut : ""} onChange={(e) => handleAttendanceChange(index, "checkOut", e.target.value)} /></td>
//                   <td><button className="update-btn" onClick={() => handleSave(row)}>Update</button></td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//           <button className="calc-att-btn" onClick={handlecalcclick}>Finalize & Calculate Salary</button>
//         </div>
//       )}

//       {/* Modal remains the same... */}
//       {isModalOpen && (
//         <div className="modal-overlay">
//           <div className="modal-content">
//             <h3>Create Custom Attendance</h3>
//             <form onSubmit={handleCreateSubmit}>
//               <div className="form-group"><label>Date</label><input type="date" required onChange={(e) => setFormData({...formData, attendance_date: e.target.value})} /></div>
//               <div className="form-group"><label>Check-in Time</label><input type="time" defaultValue="09:30" onChange={(e) => setFormData({...formData, attendance_time: e.target.value})} /></div>
//               <div className="form-group"><label>Check-out Time</label><input type="time" defaultValue="18:30" onChange={(e) => setFormData({...formData, checkout_time: e.target.value})} /></div>
//               <div className="modal-btns">
//                 <button type="button" className="cancel-btn" onClick={() => setIsModalOpen(false)}>Cancel</button>
//                 <button type="submit" className="save-btn">Create</button>
//               </div>
//             </form>
//           </div>
//         </div>
//       )}
//       <ToastContainer position="top-right" autoClose={3000} theme="colored" />
//     </div>
//   );
// };

// export default SuperAdminAttendance;



// import React, { useState, useEffect } from "react";
// import "../assets/AttendanceCalculator.css";
// import { toast, ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

// const SuperAdminAttendance = () => {
//   const [selectedMonth, setSelectedMonth] = useState(
//     new Date().toISOString().slice(0, 7)
//   );
//   const [attendanceData, setAttendanceData] = useState([]);
//   const [loading, setLoading] = useState(false);

//   // ✅ GET ALL DATES OF MONTH
//   const getAllDatesOfMonth = (month) => {
//     const [year, monthNum] = month.split("-");
//     const days = new Date(year, monthNum, 0).getDate();

//     let dates = [];
//     for (let i = 1; i <= days; i++) {
//       const day = String(i).padStart(2, "0");
//       dates.push(`${year}-${monthNum}-${day}`);
//     }
//     return dates;
//   };

//   // ✅ GROUP BY EMPLOYEE
//   const groupByEmployee = (data) => {
//     const grouped = {};

//     data.forEach((item) => {
//       const empId = item.employee_id;

//       if (!grouped[empId]) {
//         grouped[empId] = {
//           employee_id: empId,
//           attendance: [],
//         };
//       }

//       grouped[empId].attendance.push({
//         date: item.date,
//         status: item.status || "absent",
//       });
//     });

//     return Object.values(grouped);
//   };

//   // ✅ FILL MISSING DAYS
//   const fillMissingDates = (employees, month) => {
//     const allDates = getAllDatesOfMonth(month);

//     return employees.map((emp) => {
//       const map = {};
//       emp.attendance.forEach((a) => {
//         map[a.date] = a;
//       });

//       const fullAttendance = allDates.map((date) => {
//         return map[date] || {
//           date,
//           status: "absent",
//         };
//       });

//       return {
//         ...emp,
//         attendance: fullAttendance,
//       };
//     });
//   };

//   // ✅ SUMMARY
//   const addSummary = (employees) => {
//     return employees.map((emp) => {
//       let present = 0,
//         absent = 0,
//         late = 0;

//       emp.attendance.forEach((a) => {
//         if (a.status === "present") present++;
//         else if (a.status === "late") late++;
//         else absent++;
//       });

//       return {
//         ...emp,
//         summary: { present, absent, late },
//       };
//     });
//   };

//   // ✅ FETCH API
//   const fetchAttendanceData = async () => {
//     setLoading(true);
//     try {
//       const res = await fetch(
//         `https://narrowitsolution.in/api/attendance/status?admin_id=52&month=${selectedMonth}`
//       );
//       const result = await res.json();

//       if (result?.data?.length) {
//         let grouped = groupByEmployee(result.data);
//         let fullMonth = fillMissingDates(grouped, selectedMonth);
//         let finalData = addSummary(fullMonth);

//         setAttendanceData(finalData);
//       } else {
//         toast.info("No data found");
//         setAttendanceData([]);
//       }
//     } catch (err) {
//       toast.error("API Error");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchAttendanceData();
//   }, [selectedMonth]);

//   const allDates = getAllDatesOfMonth(selectedMonth);

//   return (
//     <div className="SuperAdminAttendance-container">
//       <h1>All Employees Monthly Attendance</h1>

//       <input
//         type="month"
//         value={selectedMonth}
//         onChange={(e) => setSelectedMonth(e.target.value)}
//       />

//       {loading ? (
//         <p>Loading...</p>
//       ) : (
//         <div style={{ overflowX: "auto" }}>
//           <table className="SuperAdminAttendance-table">
//             <thead>
//               <tr>
//                 <th>Employee</th>
//                 {allDates.map((d) => (
//                   <th key={d}>{d.split("-")[2]}</th>
//                 ))}
//                 <th>Present</th>
//                 <th>Late</th>
//                 <th>Absent</th>
//               </tr>
//             </thead>

//             <tbody>
//               {attendanceData.map((emp, i) => (
//                 <tr key={i}>
//                   <td>{emp.employee_id}</td>

//                   {emp.attendance.map((a, idx) => (
//                     <td
//                       key={idx}
//                       style={{
//                         background:
//                           a.status === "present"
//                             ? "#d4edda"
//                             : a.status === "late"
//                             ? "#fff3cd"
//                             : "#f8d7da",
//                       }}
//                     >
//                       {a.status === "present"
//                         ? "P"
//                         : a.status === "late"
//                         ? "L"
//                         : "A"}
//                     </td>
//                   ))}

//                   <td>{emp.summary.present}</td>
//                   <td>{emp.summary.late}</td>
//                   <td>{emp.summary.absent}</td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       )}

//       <ToastContainer />
//     </div>
//   );
// };

// export default SuperAdminAttendance;



















import React, { useState, useEffect } from "react";
import "../assets/AttendanceCalculator.css";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const SuperAdminAttendance = () => {
  const [selectedMonth, setSelectedMonth] = useState(
    new Date().toISOString().slice(0, 7)
  );
  const [attendanceData, setAttendanceData] = useState([]);
  const [loading, setLoading] = useState(false);

  // ✅ GET ALL DATES OF MONTH
  const getAllDatesOfMonth = (month) => {
    const [year, monthNum] = month.split("-");
    const days = new Date(year, monthNum, 0).getDate();

    let dates = [];
    for (let i = 1; i <= days; i++) {
      const day = String(i).padStart(2, "0");
      dates.push(`${year}-${monthNum}-${day}`);
    }
    return dates;
  };

  // ✅ GROUP BY EMPLOYEE (🔥 FINAL FIX)
  const groupByEmployee = (data) => {
    const grouped = {};

    data.forEach((item) => {
      const empId = item.employee_id;

      if (!grouped[empId]) {
        grouped[empId] = {
          employee_id: empId,
          employee: item.employee, // ✅ IMPORTANT (NAME FIX)
          attendance: [],
        };
      }

      grouped[empId].attendance.push({
        date: item.date,
        status: item.status || "absent",
      });
    });

    return Object.values(grouped);
  };

  // ✅ FILL MISSING DAYS
  const fillMissingDates = (employees, month) => {
    const allDates = getAllDatesOfMonth(month);

    return employees.map((emp) => {
      const map = {};
      emp.attendance.forEach((a) => {
        map[a.date] = a;
      });

      const fullAttendance = allDates.map((date) => {
        return map[date] || {
          date,
          status: "absent",
        };
      });

      return {
        ...emp,
        attendance: fullAttendance,
      };
    });
  };

  // ✅ SUMMARY
  const addSummary = (employees) => {
    return employees.map((emp) => {
      let present = 0,
        absent = 0,
        late = 0;

      emp.attendance.forEach((a) => {
        if (a.status === "present") present++;
        else if (a.status === "late") late++;
        else absent++;
      });

      return {
        ...emp,
        summary: { present, absent, late },
      };
    });
  };

  // ✅ FETCH API
  const fetchAttendanceData = async () => {

      const superAdminId = localStorage.getItem("adminuserId");

    setLoading(true);
    try {
      const res = await fetch(
        `https://narrowitsolution.in/api/attendance/status?admin_id=${superAdminId}&month=${selectedMonth}`
      );
      const result = await res.json();

      if (result?.data?.length) {
        const grouped = groupByEmployee(result.data);
        const fullMonth = fillMissingDates(grouped, selectedMonth);
        const finalData = addSummary(fullMonth);

        setAttendanceData(finalData);
      } else {
        toast.info("No data found");
        setAttendanceData([]);
      }
    } catch (err) {
      toast.error("API Error");
    } finally {
      setLoading(false);
    }
  };




  const formatExportData = () => {
  const data = [];

  attendanceData.forEach((emp) => {
    const row = {
      EmployeeID: emp.employee?.userId,
      Name: emp.employee?.fullName,
    };

    emp.attendance.forEach((a) => {
      const day = a.date.split("-")[2];
      row[`Day_${day}`] =
        a.status === "present"
          ? "P"
          : a.status === "late"
          ? "L"
          : "A";
    });

    row.Present = emp.summary.present;
    row.Late = emp.summary.late;
    row.Absent = emp.summary.absent;

    data.push(row);
  });

  return data;
};



const downloadExcel = () => {
  const data = formatExportData();

  const worksheet = XLSX.utils.json_to_sheet(data);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Attendance");

  const excelBuffer = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array",
  });

  const file = new Blob([excelBuffer], { type: "application/octet-stream" });
  saveAs(file, `Attendance_${selectedMonth}.xlsx`);
};


const downloadCSV = () => {
  const data = formatExportData();

  const worksheet = XLSX.utils.json_to_sheet(data);
  const csv = XLSX.utils.sheet_to_csv(worksheet);

  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  saveAs(blob, `Attendance_${selectedMonth}.csv`);
};


const downloadPDF = () => {
  const doc = new jsPDF("landscape");

  const tableColumn = [
    "Employee",
    ...allDates.map((d) => d.split("-")[2]),
    "P",
    "L",
    "A",
  ];

  const tableRows = [];

  attendanceData.forEach((emp) => {
    const row = [
      `${emp.employee?.fullName} (${emp.employee?.userId})`,
    ];

    emp.attendance.forEach((a) => {
      row.push(
        a.status === "present"
          ? "P"
          : a.status === "late"
          ? "L"
          : "A"
      );
    });

    row.push(emp.summary.present);
    row.push(emp.summary.late);
    row.push(emp.summary.absent);

    tableRows.push(row);
  });

  // ✅ THIS IS THE FIX
  autoTable(doc, {
    head: [tableColumn],
    body: tableRows,
    styles: { fontSize: 6 },
  });

  doc.save(`Attendance_${selectedMonth}.pdf`);
};


  useEffect(() => {
    fetchAttendanceData();
  }, [selectedMonth]);

  const allDates = getAllDatesOfMonth(selectedMonth);

  return (
    <div className="SuperAdminAttendance-container">
      <h1>All Employees Monthly Attendance</h1>

      {/* ✅ LEGEND */}
      <div style={{ marginBottom: 10 }}>
        <span style={{ background: "#d4edda", padding: 5 }}> P </span> Present
        <span style={{ background: "#fff3cd", padding: 5, marginLeft: 10 }}> L </span> Late
        <span style={{ background: "#f8d7da", padding: 5, marginLeft: 10 }}> A </span> Absent
      </div>

      <input
        type="month"
        value={selectedMonth}
        onChange={(e) => setSelectedMonth(e.target.value)}
      />

      {loading ? (
        <p>Loading...</p>
      ) : (
        <div style={{ overflowX: "auto" }}>
        <div style={{ margin: "10px 0" }}>
  <button onClick={downloadExcel}>Download Excel</button>
  <button onClick={downloadCSV} style={{ marginLeft: 10 }}>
    Download CSV
  </button>
  <button onClick={downloadPDF} style={{ marginLeft: 10 }}>
    Download PDF
  </button>
</div>
          <table className="SuperAdminAttendance-table">
            <thead>
              <tr>
                <th>Employee</th>
                {allDates.map((d) => (
                  <th key={d}>{d.split("-")[2]}</th>
                ))}
                <th>P</th>
                <th>L</th>
                <th>A</th>
              </tr>
            </thead>

            <tbody>
              {attendanceData.map((emp, i) => (
                <tr key={i}>
                  {/* ✅ FINAL NAME FIX */}
                  <td>
                    <b>{emp.employee?.userId}</b>
                    <br />
                    <small>Name: {emp.employee?.fullName}</small>
                  </td>

                  {emp.attendance.map((a, idx) => (
                    <td
                      key={idx}
                      style={{
                        background:
                          a.status === "present"
                            ? "#d4edda"
                            : a.status === "late"
                            ? "#fff3cd"
                            : "#f8d7da",
                        textAlign: "center",
                        fontWeight: "bold",
                      }}
                    >
                      {a.status === "present"
                        ? "P"
                        : a.status === "late"
                        ? "L"
                        : "A"}
                    </td>
                  ))}

                  <td>{emp.summary.present}</td>
                  <td>{emp.summary.late}</td>
                  <td>{emp.summary.absent}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <ToastContainer />
    </div>
  );
};

export default SuperAdminAttendance;